import { render } from "./enhance-profile.vue?vue&type=template&id=24520463&scoped=true"
import script from "./enhance-profile.vue?vue&type=script&lang=js"
export * from "./enhance-profile.vue?vue&type=script&lang=js"

import "@/css/bootstrap.min.css?vue&type=style&index=0&id=24520463&scoped=true&lang=css"
import "./enhance-profile.vue?vue&type=style&index=1&id=24520463&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24520463"]])

export default __exports__